module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_pending_request-026448520a2f6d692de7a6c580dd381a.svg";